<div class="pageheader">
    <div class="page-title">
        <h1>{{isNewRule() ? "Create" : "Edit"}} {{ isDefaultRule() ? "Default" : ""}} Error Rule</h1>
    </div>
</div>

<form (ngSubmit)="formSubmit()" #tForm="ngForm">
    @if (errorRule() != null) {
        <app-layout-container fluid>
            <app-layout-row>
                <app-layout-column [width]="8">
                    <app-textbox [ngModel]="errorRule().Name" name="name" caption="Name" required [readonly]="isDefaultRule()"></app-textbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="8">
                    <app-textbox [ngModel]="errorRule().Description" name="description" caption="Description" [readonly]="isDefaultRule()"></app-textbox>
                </app-layout-column>
            </app-layout-row>

            @if (!isDefaultRule()) {
                <app-layout-row>
                    <app-layout-column [width]="8">
                        <app-error-rules-conditions [conditions]="errorRule().Conditions" (onSummaryChange)="onConditionSummaryChange($event)"></app-error-rules-conditions>
                    </app-layout-column>
                </app-layout-row>
            }

            <app-layout-row>
                <app-layout-column [width]="8">
                    <app-error-rules-actions [actions]="errorRule()" [stakeholders]="stakeholders()" [contactTypes]="contactTypes()" (onSummaryChange)="onActionSummaryChange($event)"></app-error-rules-actions>
                </app-layout-column>
            </app-layout-row>

            <app-layout-row>
                <app-layout-column [width]="8">
                    <p>Summary</p>
                    <pre class="summary">{{summary()}}</pre>
                </app-layout-column>
            </app-layout-row>

            @if (!isDefaultRule()) {
                <app-layout-row>
                    <app-layout-column [width]="8">
                        <app-checkbox name="isEnabled" caption="Rule Is Enabled" [ngModel]="errorRule().IsEnabled"></app-checkbox>
                    </app-layout-column>
                </app-layout-row>
            }

            <app-layout-row>
                <app-layout-column [width]="1">
                    <app-button primary width="100%" submit [disabled]="tForm.invalid">Save</app-button>
                </app-layout-column>
                <app-layout-column [width]="1">
                    <app-button secondary width="100%" (buttonClick)="formCancel()">Cancel</app-button>
                </app-layout-column>
            </app-layout-row>
        </app-layout-container>
    }
</form>
